import { ErrorHandler, Injectable } from '@angular/core';

import * as Honeybadger from '@honeybadger-io/js';
import * as LogRocket from 'logrocket';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService extends ErrorHandler {
  override handleError(error: any) {
    super.handleError(error);
    LogRocket.error(error);
    LogRocket.captureException(error, {
      tags: {
        caught: false,
      },
    });
  }

  reportCaughtError(error: any) {
    console.error(error);
    LogRocket.error(error);
    LogRocket.captureException(error, {
      tags: {
        caught: true,
      },
    });
  }

  reportSearchError(error: any, collection: string) {
    this.reportCatastrophicError(error, 'Search Failure', { collection });
  }

  reportSearchDegradation(collection: string) {
    this.reportCatastrophicError(
      new Error(`Detected search degradation in ${collection}`),
      'Search Degradation',
      { collection },
    );
  }

  reportCatastrophicError(
    error: any,
    title: string,
    extra?: Record<string, string>,
  ) {
    this.reportCaughtError(error);
    LogRocket.track(title, extra);
    Honeybadger.notify(error.originalError || error, title, {
      ...extra,
      catastrophic: true,
    });
  }
}
